<template>
    <div>
        <upload-file-select isPartOfForm @sendFile="addFileOrUpload"></upload-file-select>
        <div v-if="value && value.length" class="mt-4">
            <paginated-table :fields="tableFields" :items="value" :showCaption="false">
                <template v-slot:cell(icon)="data">
                    <b-icon-link45deg v-if="data.item.data.fileType === 'link'" variant="primary"></b-icon-link45deg>
                    <b-icon-image v-else-if="data.item.data.fileType.includes('image')" variant="primary"></b-icon-image>
                    <b-icon-file-earmark-pdf v-else-if="data.item.data.fileType.includes('pdf')" variant="primary"></b-icon-file-earmark-pdf>
                    <b-icon-file-earmark-text v-else-if="data.item.data.fileType.includes('application')" variant="primary"></b-icon-file-earmark-text>
                    <b-icon-folder v-else variant="primary"></b-icon-folder>
                </template>
                <template v-slot:cell(fileName)="data">
                    <span class="clickable" @click="openFile(data.item.data.url)">{{ data.item.data.name }}</span>
                </template>
                <template v-slot:cell(remove)="data">
                    <b-icon-trash class="clickable" variant="danger" @click="removeFile(data.index)"></b-icon-trash>
                </template>
            </paginated-table>
        </div>
    </div>
</template>

<script>
import UploadFileSelect from '@/components/base/forms/UploadFileSelect.vue'
import PaginatedTable from '@/components/base/PaginatedTable'
import { BIcon } from 'bootstrap-vue'

export default {
    components: { UploadFileSelect, BIcon, PaginatedTable },
    props: {
        value: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            tableFields: [
                {
                    label: '',
                    key: 'icon'
                },
                {
                    label: this.$t('name'),
                    key: 'fileName'
                },
                {
                    label: this.$t('file-type-column'),
                    key: 'data.category.name',
                    formatter: (value, key, item) => {
                        return !value ? this.$t('undefined') : this.$i18nHelpers.normalize(value)
                    }
                },
                {
                    label: '',
                    key: 'remove'
                }
            ]
        }
    },
    methods: {
        addFileOrUpload (file) {
            this.emitUpdatedValue([...this.value, file])
        },
        removeFile (index) {
            this.emitUpdatedValue(this.value.filter((_, i) => i !== index))
        },
        emitUpdatedValue (newValue) {
            this.$emit('input', newValue)
        },
        openFile (url) {
            window.open(url.indexOf('http') > -1 ? url : `http://${url}`, '_blank')
        }
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/forms/UploadFileGroupForm.vue